import { makeStyles } from '@material-ui/core/styles';

export const vendorInvoiceStyles = makeStyles((theme) => ({
    embedContainer: {
        width: '100%',
        height: '80vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative'
    },
    embed: {
        width: '100%',
        height: '100%',
        border: 'none'
    },
    openInNewTab: {
        display: "flex",
        alignItems: "center",
    },
    linkContent: {
        padding: '0.5em',
        position: "absolute",
        top: '3.5em',
        right: '2.5em',
        color: "white",
        fontWeight: "bold",
        backgroundColor: theme.palette.background.default,
        borderRadius: '5px',
        boxShadow: theme.shadows[3],
        zIndex: '1'
    },
    editDocument: {
        marginTop: theme.spacing(2)
    },
    groupLabel: {
        fontWeight: 500,
        fontSize: '1.1rem',
        marginTop: theme.spacing(2),
    },
    serviceHeaders: {
        fontWeight: 500,
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main
    },
    editServiceContainer: {
        marginBottom: theme.spacing(2)
    },
    serviceDropDownLine: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    serviceGroupLabel: {
        fontWeight: 500,
        fontSize: '1.1rem',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between'
    },
    serviceDivider: {
        margin: theme.spacing(2, 0),
        backgroundColor: theme.palette.divider
    },
    autoComplete: {
        backgroundColor: theme.palette.background.default,
        margin: '0.5rem 0',
        padding: '0.5rem 0 0.5rem 0.5rem',
        color: theme.palette.primary.main,
        borderRadius: '4px',
        width: '100%',

        '&.MuiOutlinedInput-adornedEnd': {
            backgroundColor: theme.palette.background.default,
        },
        '&.css-1qqsdnr-MuiAutocomplete-root .MuiOutlinedInput-root': {
            padding: '0 !important',
        },
        '&.MuiAutocomplete-inputRoot': {
            padding: '0 !important',
        },
        '&.Mui-disabled': {
            opacity: 0.5,
        },
        '& fieldset': {
            border: 'none'
        },
        '& .MuiChip-root': {
            backgroundColor: 'white',
            borderRadius: '3px',
            color: theme.palette.primary.main,
            fontWeight: 400
        }
    },
    warningChip: {
        fontWeight: 500,
        color: '#dd742c',
        borderColor: '#dd742c',
    },
    linkedWorkOrders: {
        paddingLeft: '1rem',
        marginLeft: '1rem'
    },
    matchBtn: {
        marginLeft: '0.5rem',
        marginRight: '0.5rem',
        padding: '0.2rem 1rem',
        backgroundColor: '#f9f2ff',
        border: '0.5px solid',
        borderColor: 'rgb(138, 66, 208)',
        color: 'rgb(138, 66, 208)'
    },
    addActivityBtn: {
        marginLeft: '0.5rem',
        marginTop: '8px',
        marginBottom: '8px',
        padding: '0.2rem 1rem',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
        borderRadius: 4,
        boxShadow: theme.shadows[0],
    },
    description: {
        padding: theme.spacing(1),
        borderRadius: '5px',
        marginTop: theme.spacing(1),
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: 'white'
    },
    matchDescription: {
        padding: theme.spacing(1),
        borderRadius: '5px',
        marginTop: theme.spacing(1),
        /* Gradient border: use two backgrounds and background-clip to simulate a gradient border while keeping inner background solid */
        backgroundImage: `linear-gradient(white, white), linear-gradient(90deg, #8a42d0 0%, #4737ffff 50%, #d0a5feff 100%)`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
        border: '1px solid transparent'
    },
    matchContainer: {
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        border: `1px solid gray`,
        borderRadius: '5px',
        backgroundColor: theme.palette.background.paper
    },
    arrowIcon: {
        fontSize: '2rem',
        fill: '#aa5dfcff',
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(1)
    },
    subTitle: {
        margin: theme.spacing(0, 2),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    acceptedMatch: {
        backgroundColor: '#f1faf4ff',
        borderColor: '#04da04ff'
    },
    acceptAll: {
        margin: theme.spacing(1),
        color: '#04da04ff',
        borderColor: '#04da04ff'
    },
    rejectAll: {
        margin: theme.spacing(1),
        color: 'red',
        borderColor: 'red'
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '1rem',
        marginLeft: 'auto',
        marginRight: '2rem'
    },
    acceptIcon: {
        fill: '#04da04ff'
    },
    rejectIcon: {
        fill: 'red'
    },
    itemIcon: {
        paddingRight: '1em'
    },
    matchTitle: {
        fontSize: 12,
    }
}));